import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FieldTitle } from 'ra-core';
import TextField from '@mui/material/TextField';
import * as ReactColor from 'react-color';

// Import CSS for the color input
import './ColorInput.css';

const ColorFieldComponent = ({ source, record = {}, className }) => (
  <div style={{ display: 'flex' }}>
    <div
      style={{
        width: '20px',
        height: '20px',
        background: record?.[source],
        marginRight: '5px',
      }}
    />
    <span className={className}>{record?.[source]}</span>
  </div>
);

// Memoize the component for performance optimization (replacing `recompose/pure`)
const PureTextField = React.memo(ColorFieldComponent);

ColorFieldComponent.propTypes = {
  addLabel: PropTypes.bool,
  className: PropTypes.string,
  elStyle: PropTypes.object,
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

const ColorInputComponent = (props) => {
  const [show, setShow] = useState(false);
  
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleChange = ({ hex }) => {
    props.input.onChange(hex);
  };

  const {
    label,
    source,
    meta,
    className,
    options,
    picker,
    input,
    resource,
    helperText,
    isRequired,
  } = props;

  const {
    touched,
    error,
  } = meta;

  const Picker = ReactColor[`${picker}Picker`];

  return (
    <div>
      <TextField
        {...input}
        margin="normal"
        onFocus={handleOpen}
        label={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        error={!!(touched && error)}
        helperText={touched && error || helperText}
        className={className}
      />
      {show ? (
        <div className="ColorInput-popup">
          <div className="ColorInput-cover" onClick={handleClose} />
          <Picker
            {...options}
            color={input.value}
            onChange={handleChange}
          />
        </div>
      ) : null}
    </div>
  );
};

ColorInputComponent.propTypes = {
  label: PropTypes.string,
  options: PropTypes.object,
  source: PropTypes.string,
  field: PropTypes.object,
  helperText: PropTypes.string,
  fieldState: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  formState: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
  picker: (props, propName, componentName) =>
    !ReactColor[`${props[propName]}Picker`] &&
    new Error(`Invalid prop \`${propName}\` supplied to \`${componentName}\`.`)
};

ColorInputComponent.defaultProps = {
  picker: 'Chrome',
  options: {
    disableAlpha: true
  },
};

export const ColorField = PureTextField;
export const ColorInput = ColorInputComponent;
